/* component-blog-toc.js — sommaire auto pour les articles (>=4 titres). */
(function(){
  function slug(s){return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,60);}
  function run(){
    var main=document.getElementById('MainContent'); if(!main) return;
    if(document.getElementById('am-toc')) return; /* deja gere par la page */
    var nodes=[].slice.call(main.querySelectorAll('.article-template .rte h2,.rich-text__blocks>.h2,.image-with-text__heading'));
    var skip=/questions fr|nos guides|envie d|contactez|sommaire/i;
    var items=[];
    nodes.forEach(function(n){
      var t=(n.textContent||'').trim();
      if(!t||skip.test(t)) return;
      if(n.closest('.color-accent-1')||n.closest('.color-background-2')||n.closest('.am-cta')) return;
      var id=n.id||('s-'+slug(t)); n.id=id; items.push({id:id,t:t,el:n});
    });
    if(items.length<4) return;
    var nav=document.createElement('nav'); nav.id='am-toc'; nav.className='am-toc';
    var h='<p class="am-toc__title">Sommaire</p><ol class="am-toc__list">';
    items.forEach(function(it){ h+='<li><a href="#'+it.id+'">'+it.t.replace(/</g,'&lt;')+'</a></li>'; });
    nav.innerHTML=h+'</ol>';
    var first=items[0].el;
    var section=first.closest('.rich-text')||first.closest('.shopify-section');
    if(first.closest('.rich-text__blocks')&&section){ section.parentNode.insertBefore(nav,section); }
    else { first.parentNode.insertBefore(nav,first); }
    main.addEventListener('click',function(e){var a=e.target.closest('.am-toc__list a');if(!a)return;e.preventDefault();var el=document.querySelector(a.getAttribute('href'));if(el)window.scrollTo({top:el.getBoundingClientRect().top+window.pageYOffset-90,behavior:'smooth'});});
  }
  if(document.readyState!=='loading') run(); else document.addEventListener('DOMContentLoaded',run);
})();
